import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Checkbox.styles'

const Checkbox = (props) => {
  const { id, value, checked, handleChange, children, disabled } = props

  return (
    <Styled.Container>
      <input
        id={ id }
        className='sr-only'
        type='checkbox'
        value={ value }
        onChange={ () =>
          handleChange({
            filter: id,
            value,
          })
        }
        checked={ checked }
        disabled={ disabled }
      />
      <label className='label' htmlFor={ id }>
        {children}
      </label>
    </Styled.Container>
  )
}

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
}

Checkbox.propTypes = {
  /** id attribute for the element */
  id: PropTypes.string.isRequired,
  /** group name for grouping checkboxes */
  name: PropTypes.string,
  /** programmatic value of checkbox */
  value: PropTypes.string,
  /** checked state of checkbox */
  checked: PropTypes.bool,
  /** children elements within checkbox label */
  children: PropTypes.node.isRequired,
  /** enable/disable checkbox */
  disabled: PropTypes.bool,
  /** change event handler */
  handleChange: PropTypes.func.isRequired,
  // excludeFromStorage: React.PropTypes.bool,
}

export default Checkbox
